import { IButtonStyles, IconButton, TextField } from "@fluentui/react";
import React from 'react';
import { ITenant } from "../../../data-structures/interfaces";

const revealButtonStyles: IButtonStyles = {
	root: {
		backgroundColor: 'transparent',
		color: 'var(--db-fg)',
	},
	rootHovered: {
		backgroundColor: 'transparent',
		color: 'var(--db-fg)',
	},
	rootPressed: {
		backgroundColor: 'transparent',
	},
}

interface ISecuredInputProps {
	inputLabel: string;
	propertyValue: string;
	propertyName: string;
	setNewTenant: (value: React.SetStateAction<ITenant>) => void;
	hideReveal?: boolean;
}

export const SecuredInput: React.FC<ISecuredInputProps> = (props: ISecuredInputProps) => {
	const [isValueVisible, setIsValueVisible] = React.useState<boolean>(false);

	const onRevealValueClick = () => {
		setIsValueVisible(prev => !prev);
	};

	const renderSuffix = () => {
		return (
			<IconButton
				iconProps={{ iconName: isValueVisible ? "Hide" : "RedEye" }}
				ariaLabel={isValueVisible ? "Hide value" : "Show value"}
				onClick={onRevealValueClick}
				styles={revealButtonStyles}
				tabIndex={-1}
			/>
		);
	};

	return (
		<TextField
			label={props.inputLabel}
			styles={{
				// Blend the suffix (reveal-eye container) with the input field:
				// --db-bg is #fff in light (was "white") and #1f1f1f in dark, so a
				// white block no longer floats behind the eye icon in dark mode.
				suffix: {
					backgroundColor: "var(--db-bg)"
				}
			}}
			type={!props.hideReveal && isValueVisible ? "text" : "password"}
			value={props.propertyValue}
			onChange={(_, newValue?: string) => props.setNewTenant(prevTenant => ({ ...prevTenant, [props.propertyName]: newValue }))}
			onRenderSuffix={props.hideReveal ? undefined : renderSuffix}
			canRevealPassword={false}
		/>
	);
};
